import { DetailEntry, EntryItem } from '@com-delta-omnichannel/aura';

export const PartnerFlightsMocks: EntryItem = {
  content: {
    subtitle: '',
    title: 'Delta & Partner Flights'
  },
  icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/mqd-summary/delta-flights-solid.svg',
  state: '',
  value: [],
  border: 'none',
  ariaLabel: {
    icon: 'Delta & Partner Flights'
  }
};

export const CoBrandMocks: EntryItem = {
  content: {
    subtitle: '',
    title: 'AMEX Co-Brand Cards'
  },
  icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/mqd-summary/delta-card.svg',
  state: '',
  value: [],
  border: 'none',
  ariaLabel: {
    icon: 'AMEX Co-Brand Cards'
  }
};

export const VacationsMocks: EntryItem = {
  content: {
    subtitle: '',
    title: 'Delta Vacations'
  },
  icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/mqd-summary/delta-vacations-solid.svg',
  state: '',
  value: [],
  border: 'none',
  ariaLabel: {
    icon: 'Delta Vacations'
  }
};

export const CarMocks: EntryItem = {
  content: {
    subtitle: '',
    title: 'Delta+ Cars'
  },
  icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/mqd-summary/delta-rental-car-solid.svg',
  state: '',
  value: [],
  border: 'none',
  ariaLabel: {
    icon: 'Delta+ Cars'
  }
};

export const StaysMocks: EntryItem = {
  content: {
    subtitle: '',
    title: 'Delta+ Stays'
  },
  icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/mqd-summary/delta-stays-solid.svg',
  state: '',
  value: [],
  border: 'none',
  ariaLabel: {
    icon: 'Delta+ Stays'
  }
};

export const OthersMocks: EntryItem = {
  content: {
    subtitle: '',
    title: 'Other'
  },
  icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/mqd-summary/other-mqd-solid.svg',
  state: '',
  value: [],
  border: 'none',
  ariaLabel: {
    icon: 'Other'
  }
};

export const TierMilesMocks: DetailEntry[] = [
  {
    info: null,
    icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/educational-content/earn-silver-miles.png',
    title:
      '<span class="education-content-page__sections__toggle-area__tier-miles__title">Silver Medallion</span>',
    type: 'mixed',
    value:
      '<span class="education-content-page__sections__toggle-area__tier-miles__value">7 miles per dollar</span>'
  },
  {
    info: null,
    icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/educational-content/earn-gold-miles.png',
    title:
      '<span class="education-content-page__sections__toggle-area__tier-miles__title">Gold Medallion</span>',
    type: 'mixed',
    value:
      '<span class="education-content-page__sections__toggle-area__tier-miles__value">8 miles per dollar</span>'
  },
  {
    info: null,
    icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/educational-content/earn-platinum-miles.png',
    title:
      '<span class="education-content-page__sections__toggle-area__tier-miles__title">Platinum Medallion</span>',
    type: 'mixed',
    value:
      '<span class="education-content-page__sections__toggle-area__tier-miles__value">9 miles per dollar</span>'
  },
  {
    info: null,
    icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/educational-content/earn-diamond-miles.png',
    title:
      '<span class="education-content-page__sections__toggle-area__tier-miles__title">Diamond Medallion</span>',
    type: 'mixed',
    value:
      '<span class="education-content-page__sections__toggle-area__tier-miles__value">11 miles per dollar</span>'
  }
];

export const EarnMilesMocks: EntryItem = {
  content: {
    subtitle: '',
    title:
      '<span class="education-content-page__sections__toggle-area__title">Earn More Miles</span>'
  },
  icon: '',
  state: '',
  value: [],
  border: 'none',
  ariaLabel: {
    icon: ''
  }
};

export const UpgradesMocks: EntryItem = {
  content: {
    subtitle: '',
    title:
      '<span class="education-content-page__sections__toggle-area__title">Complimentary Upgrades</span>'
  },
  icon: '',
  state: '',
  value: [],
  border: 'none',
  ariaLabel: {
    icon: ''
  }
};

export const PreferredMocks: EntryItem = {
  content: {
    subtitle: '',
    title:
      '<span class="education-content-page__sections__toggle-area__title">Preferred Seats</span>'
  },
  icon: '',
  state: '',
  value: [],
  border: 'none',
  ariaLabel: {
    icon: ''
  }
};

export const ChoiceBenefitsMocks: EntryItem = {
  content: {
    subtitle: '',
    title:
      '<span class="education-content-page__sections__toggle-area__title">Choice Benefits</span>'
  },
  icon: '',
  state: '',
  value: [],
  border: 'none',
  ariaLabel: {
    icon: ''
  }
};
